import { MomentDateAdapter } from "@angular/material-moment-adapter";

export class MadDateAdapter extends MomentDateAdapter {
  override getFirstDayOfWeek(): number {
    return 1;  
  }
}